module.exports = __webpack_public_path__ + "img/Number=65.8ca419fb.png";